import { useCallback, useState } from "react";
import { AxiosRequest } from "_services/api";
import type { IProcessoTaxa } from "../ModalSelecionarProcessos";

export function useLoteProcessos() {
  const msAw = AxiosRequest.makeApi(process.env.REACT_APP_MS_AW);

  const [carregando, setCarregando] = useState(false);

  const carregar = useCallback(
    async (idLote: number): Promise<IProcessoTaxa[]> => {
      setCarregando(true);
      try {
        const { data } = await msAw.get(
          `/financeiro/pagamento-taxa/lote/${idLote}/processos`,
        );
        return data?.itens ?? [];
      } catch {
        return [];
      } finally {
        setCarregando(false);
      }
    },
    [],
  );

  return { carregando, carregar };
}
